import { render, staticRenderFns } from "./PhoneCardList.vue?vue&type=template&id=46ea98b2&scoped=true&"
import script from "./PhoneCardList.vue?vue&type=script&lang=js&"
export * from "./PhoneCardList.vue?vue&type=script&lang=js&"
import style0 from "./PhoneCardList.vue?vue&type=style&index=0&id=46ea98b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ea98b2",
  null
  
)

export default component.exports